const initialState = {

  mandatoryFieldsBasicDetails: [
    { type: "Service Type", valueFilled: true, name: 'rentalStatus', isVisible: true }, //valueFilled:true set by default for the default value
    { type: "Asset Classification", valueFilled: true, name: 'assetClassification', isVisible: true }, //valueFilled:true set by default for the default value
    { type: "Asset Description", valueFilled: false, name: 'assetDescription', isVisible: true },
    { type: "Type Code Description", valueFilled: false, name: 'typeCodeDescription', isVisible: true },
    { type: "Location Name", valueFilled: false, name: 'locationName', isVisible: true },
    { type: "Work Group", valueFilled: false, name: 'workGroup', isVisible: true },
    { type: "PPM Required", valueFilled: true, name: 'ppmRequired', isVisible: true }, //valueFilled:true set by default for the default value
    { type: "PPM Status", valueFilled: false, name: 'ppmStatus', isVisible: true },
    { type: "Reason", valueFilled: false, name: 'reason', isVisible: false }

  ],

  mandatoryFieldsAssetSpecification: [
    { type: "Make", valueFilled: false, name: 'make', isVisible: true },
    { type: "Brand", valueFilled: false, name: 'brand', isVisible: true },
    { type: "Model", valueFilled: false, name: 'model', isVisible: true },
    { type: "Serial No.", valueFilled: false, name: 'serialNo', isVisible: true },
    { type: "Manufacturer", valueFilled: false, name: 'manufacturer', isVisible: true },
    { type: "Life Span(yrs)", valueFilled: false, name: 'lifeSpan', isVisible: false },
  ],

  mandatoryFieldsPurchaseDetails: [
    { type: "Purchase Cost in RM", valueFilled: false, name: 'purchaseCost', isVisible: true },
    { type: "Purchase Flag", valueFilled: false, name: 'purchaseFlag', isVisible: true },
    { type: "Warranty Start Date", valueFilled: false, name: 'warrantyStartDate', isVisible: true },
    { type: "Warranty End Date", valueFilled: false, name: 'warrantyEndDate', isVisible: true },
    { type: "Commissioning Date", valueFilled: false, name: 'commissioningDate', isVisible: true },
    { type: "Vendor", valueFilled: false, name: 'vendor', isVisible: true },
    { type: "Asset Transfer", valueFilled: false, name: 'assetTransferDepartment', isVisible: false },
  ],
  isMandatoryRequiredEnabled: false,
  isViewEnabled: false,
  isauthorized: false
};

const mandatoryFieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_BASIC_DETAILS_MANDATORY_FIELDS":
      return {
        ...state,
        mandatoryFieldsBasicDetails: action.payload,
      };

    case "UPDATE_ASSET_SPECIFICATION_MANDATORY_FIELDS":
      return {
        ...state,
        mandatoryFieldsAssetSpecification: action.payload,
      };
    case "UPDATE_PURCHASE_DETAILS_MANDATORY_FIELDS":
      return {
        ...state,
        mandatoryFieldsPurchaseDetails: action.payload,
      };
    case "UPDATE_MANDATORY_REQUIRED_ENABLED":
      return {
        ...state,
        isMandatoryRequiredEnabled: action.payload,
      };

    case "VIEW_ENABLED":
      return {
        ...state,
        isViewEnabled: action.payload,
      };
    case "UPDATE_ISAUTHORIZED":
      return {
        ...state,
        isauthorized: action.payload,
      };
    case "CLEAR_MANDATORY_FIELD":
      return {};
    default:
      return state;
  }
};

export default mandatoryFieldsReducer;
